import styled, { css } from 'styled-components';
import { getTextType, getGridSpan, mq, btnReset } from '../../../stylesheets/tools';

const StyledPanoImage = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  width: 100%;

  button {
    ${btnReset}
  }

  .panoImage__button {
    position: absolute;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  svg {
    position: absolute;
    top: 10px;
    left: 10px;

    ${mq('m')} {
      top: 30px;
      left: 30px;
    }
  }

  img {
    width: 100%;
    height: auto;
  }

  ${props =>
    props.slider &&
    css`
      height: auto;
      width: auto;
      padding-bottom: 0;

      ${mq('m')} {
        height: 100%;
      }
    `}
`;

const StyledPanoImageFullscreen = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    position: absolute;
    top: 40px;
    right: 40px;
    ${btnReset}

    svg {
      fill: #fff;
    }
  }

  .panoImage__fullscreen-wrapper {
    width: 80%;
  }
`;

const StyledPanoImageSkeleton = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding-bottom: calc(9 / 16 * 100% - 10px);
  border: 3px solid black;
  background: #fff;

  ${mq('m')} {
    border: 5px solid black;
  }

  span {
    position: absolute;
    width: 100%;
    text-transform: uppercase;
    bottom: 0;
    left: 0;
    padding: 30px 30px 40px;
    ${getTextType('subline')}

    ${mq('m')} {
      width: ${getGridSpan(8)};
      ${getTextType('primary')}
    }

    &:before {
      position: absolute;
      content: '';
      width: 50px;
      height: 3px;
      top: 0px;
      left: -25px;
      background: #000;

      ${mq('m')} {
        height: 5px;
      }
    }
  }
`;
export { StyledPanoImage, StyledPanoImageFullscreen, StyledPanoImageSkeleton };
